import { PageHeader } from '@/shared/components/PageHeader';
import { Award } from 'lucide-react';
import SkillsStep from '../components/SkillsStep';

export default function SkillsPage() {
  return (
    <div className="h-full flex flex-col bg-background overflow-hidden">
      <PageHeader
        title="Skills"
        subtitle="Manage skills for the Skills Matrix"
        icon={<Award className="w-7 h-7" style={{ color: '#E84A2B' }} />}
        breadcrumbs={[
          { label: 'Settings', href: '/settings' },
          { label: 'Skills', current: true },
        ]}
      />
      <div className="flex-1 overflow-y-auto px-6 pb-6 pt-2">
        <SkillsStep />
      </div>
    </div>
  );
}
